module.exports = __webpack_public_path__ + "static/media/location-home.af13a86f.svg";